import router from '@/router'
import api from '@/api'
import endpoints from '@/api/endpoints'

const state = {
    tokens: {
        userToken: null,
        refreshToken: null
    },
    roles: localStorage.getItem('roles') !== undefined ? JSON.parse(localStorage.getItem('roles')) : [],
    hasDefaultAddress: false
}

const getters = {
    authorization: (state) => !!state.tokens.userToken,
    hasDefaultAddress: (state) => state.hasDefaultAddress,
    isSuperAdmin: (state) => state.roles.includes('ROLE_SUPER_ADMIN') || state.roles.includes('ROLE_ADMIN')
}

const mutations = {
    TOKENS(state, value) {
        // Expected object
        // value = { 
        //     save: false, // (true)
        //     tokens: {
        //         token: '',
        //         refresh_token: ''
        //     }
        // }
        localStorage.setItem('userSave', value.save)
        localStorage.setItem('userToken', value.tokens.token)
        localStorage.setItem('refreshToken', value.tokens.refreshToken)
        if (value.roles) {
            localStorage.setItem('roles', JSON.stringify(value.roles))
            state.roles = value.roles
        }
        state.tokens.userToken = value.tokens.token
        state.tokens.refreshToken = value.tokens.refreshToken
    },
    LOGOUT_TIMER() {
        let timeoutId
        function startTimer() {
            timeoutId = window.setTimeout(() => {
                // LOGOUT
                localStorage.clear()
                state.tokens.userToken = null
                state.tokens.refreshToken = null
                router.push('/')
            }, 1200000)
        }
        function resetTimer() {
            window.clearTimeout(timeoutId)
            startTimer()
        }
        function setupTimers() {
            document.addEventListener('mousemove', resetTimer, false)
            document.addEventListener('mousedown', resetTimer, false)
            document.addEventListener('keypress', resetTimer, false)
            document.addEventListener('touchmove', resetTimer, false)

            startTimer()
        }
        setupTimers()
    },
    LOGOUT(state, redirectTo) {
        localStorage.clear()
        state.role = null
        state.tokens.userToken = null
        state.tokens.refreshToken = null
        if (redirectTo) {
            router.push({...redirectTo})
        } else {
            router.push('/')
        }
    },
    EXIST_DEFAULT_ADDRESS(state, value) {
        state.hasDefaultAddress = value
    },
}

const actions = {
    getUserAddresses() {
        return api('GET', endpoints.userAddresses).then(response => response)
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js